// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__z3u6R","info":"PatientInfo_info__2AmBI"};